MxToolbarNavigationService.$inject = ['$q', '$timeout', '$document', 'mx.shell.NavigationService', 'mx.shell.EventService'];
export function MxToolbarNavigationService($q, $timeout, $document, navigationService, eventService) {
	const service = {
		MAX_CHILDREN_LEVEL: 3, // level-0 - root-items, and plus 3 levels of children
		MAX_CHILDREN_NUMBER: [5, 6, 6, 6], // root-items, level-1, level2, ...
		itemClickHandler,
		showMoreClick,
	};
	let navItems = [];
	Object.defineProperty(service, 'navItems', {
		get() {
			return navItems;
		},
		set(newItems) {
			init(newItems);
		},
	});

	navigationService.get().then((navItems) => {
		init(navItems);

		eventService.subscribeGlobal(mx.shell.EventCodes.CurrentNavigationItemChanged, () => {
			$timeout(() => {
				setCurrentClasses();
			});
		});

		eventService.subscribeGlobal(mx.shell.EventCodes.NavigationLoaded, (event, { navItems }) => {
			init(navItems);
		});
	});

	return service;

	function itemClickHandler($event, item) {
		$event.preventDefault();
		$event.stopPropagation();
		navigationService.currentItem = item;

		const hoveredRootItem = $document[0].querySelector('.mx-shell-toolbar-navigation .root-items > li.hovered');
		if (hoveredRootItem) {
			hoveredRootItem.classList.remove('hovered');
		}
	}

	function findFirstClickableChild({ children }) {
		let clickableChild;
		(children || []).some((child) => {
			if (child.route) {
				clickableChild = child;
				return true;
			}
		});

		if (clickableChild) {
			return clickableChild;
		}

		(children || []).some((child) => {
			clickableChild = findFirstClickableChild(child);
			if (clickableChild) {
				return true;
			}
		});

		return clickableChild;
	}

	function showMoreClick($event, item) {
		if (!item.route) {
			item = findFirstClickableChild(item);
		}

		if (item) {
			itemClickHandler($event, item);
		}
	}

	function init(newItems) {
		if (!Array.isArray(newItems)) {
			return;
		}

		$q.all(
			newItems.map(
				(
					item // init 3 levels of children
				) =>
					initChildrenLevels(item, service.MAX_CHILDREN_LEVEL).then((existLevels) => {
						item.existLevelsOfChildren = existLevels;
					})
			)
		).then(() => {
			if (newItems.length > service.MAX_CHILDREN_NUMBER[0]) {
				service.showRootMoreButton = true;
				navItems = newItems.slice(0, service.MAX_CHILDREN_NUMBER[0]);
				const rootMoreChildren = newItems.slice(service.MAX_CHILDREN_NUMBER[0], newItems.length);
				service.rootMoreItem = {
					children: rootMoreChildren,
					existLevelsOfChildren: Math.min(
						Math.max.apply(
							null,
							rootMoreChildren.map(({ existLevelsOfChildren }) => existLevelsOfChildren)
						),
						service.MAX_CHILDREN_LEVEL
					),
				};
			} else {
				navItems = newItems;
				service.showRootMoreButton = false;
			}

			eventService.dispatchEvent(mx.shell.EventCodes.ToolbarNavigationLoaded, navItems);
			$timeout(() => {
				setCurrentClasses();
			});
		});
	}

	function initChildrenLevels(item, numOfLevels) {
		if (!item) {
			return $q.when(null);
		}

		if (isNaN(numOfLevels) || numOfLevels < 1) {
			numOfLevels = 1;
		}

		let promise = $q.when({
			existLevels: 0,
			items: [item],
		});
		for (let i = 0; i < numOfLevels; i++) {
			promise = promise.then(initChildren);
		}

		return promise.then(({ existLevels }) => existLevels);
	}

	function initChildren(config) {
		if (!Array.isArray(config.items)) {
			return $q.when([]);
		}

		return $q.all(config.items.map((item) => navigationService.loadChildren(item))).then((arrayOfChildren) => {
			const children = Array.prototype.concat.apply([], arrayOfChildren);
			if (children.length > 0) {
				config.existLevels++;
			}
			return {
				existLevels: config.existLevels,
				items: children,
			};
		});
	}

	function setCurrentClasses() {
		const navDOMItems = $document[0].querySelectorAll('li.mx-toolbar-nav-item');
		navigationService.getFlatArrayOfNavItems().then((navItems) => {
			navDOMItems.forEach((item) => {
				const navItem = _.find(navItems, { id: item.id });
				if (navItem) {
					toggleClasses(navItem, item);
				}
			});
		});
	}

	function toggleClasses(navItem, navDOMItem) {
		if (!navItem || !navDOMItem) {
			return;
		}
		if (navDOMItem.classList.contains('activated') + navItem.activated === 1) {
			// XOR
			navDOMItem.classList.toggle('activated');
		}

		if (navDOMItem.classList.contains('current') + navItem.current === 1) {
			// XOR
			navDOMItem.classList.toggle('current');
		}
	}
}
